<script lang="ts">
	import { slide, fade } from 'svelte/transition'

	import OpenIcon from '$lib/icons/OpenIcon.svelte'
	import ClosedIcon from '$lib/icons/ClosedIcon.svelte'
	import type { Snippet } from 'svelte'

	interface Props {
		head: Snippet
		details: Snippet
		[key: string]: any
	}

	let { head, details, ...rest }: Props = $props()
	let open = $state(false)

	const handleClick = () => (open = !open)
</script>

<div class={`rounded-xl ${rest.shadow ?? 'shadow-xl'}`}>
	<h2>
		<button
			type="button"
			class="flex items-center justify-between w-full p-5 font-medium rtl:text-right gap-3"
			class:rounded-xl={!open}
			class:rounded-t-xl={open}
			aria-expanded="true"
			onclick={handleClick}
		>
			<span>
				{@render head()}
			</span>
			<span class="w-5">
				{#if open}
					<span in:fade>
						<ClosedIcon />
					</span>
				{:else}
					<span in:fade>
						<OpenIcon />
					</span>
				{/if}
			</span>
		</button>
	</h2>
	{#if open}
		<div transition:slide>
			<div class="p-5">
				{@render details()}
			</div>
		</div>
	{/if}
</div>
